import React, { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Toaster = lazy(() => import("@/components/ui/sonner").then((mod) => ({ default: mod.Toaster })));

const StorefrontLayout = () => (
  <div className="min-h-screen bg-black text-bone flex flex-col">
    <Header />
    <main className="flex-1 pt-16">
      <Outlet />
    </main>
    <Footer />
    <Suspense fallback={null}>
      <Toaster theme="dark" position="top-right" />
    </Suspense>
  </div>
);

export default StorefrontLayout;
